"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _reactSizes = _interopRequireDefault(require("react-sizes"));

var MEDIUM = 768;
var LARGE = 1024;

var getSize = function getSize(width) {
  if (width >= LARGE) return 'lg';
  if (width >= MEDIUM) return 'md';
  return 'sm';
};

var mapSizesToProps = function mapSizesToProps(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return {
    screenWidth: width,
    screenHeight: height,
    screenSize: getSize(width)
  };
};

var _default = function _default(Component) {
  return (0, _reactSizes.default)(mapSizesToProps)(Component);
};

exports.default = _default;